import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth

object FirebaseAuthSession {
    suspend fun requireUid(): String {
        val auth = Firebase.auth
        auth.currentUser?.uid?.let { return it }
        return auth.signInAnonymously().user?.uid
            ?: auth.currentUser?.uid
            ?: error("Anonymous Firebase sign-in did not return a user.")
    }
}
